var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_4_1",
    "data-name": "Component 4 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_901",
    "data-name": "Ellipse 901",
    fill: "#fff",
    stroke: "#ff4f01",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 72.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "money_1_",
    "data-name": "money (1)",
    transform: "translate(43.882 42.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215664",
    "data-name": "Path 215664",
    d: "M145.98,34.894a17.447,17.447,0,1,0-17.447-17.447A17.467,17.467,0,0,0,145.98,34.894ZM144.157,9.842V9.635a1.823,1.823,0,1,1,3.647,0v.13h.13a1.823,1.823,0,0,1,0,3.647H145a1.106,1.106,0,0,0,0,2.212h1.953a4.752,4.752,0,0,1,.847,9.429v.207a1.823,1.823,0,0,1-3.647,0v-.13h-.13a1.823,1.823,0,0,1,0-3.647h2.929a1.106,1.106,0,1,0,0-2.212H145a4.752,4.752,0,0,1-.847-9.429Z",
    transform: "translate(-112.909)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215665",
    "data-name": "Path 215665",
    d: "M452.5,53.605l3.906-1.953a1.823,1.823,0,0,0-1.631-3.262l-3.906,1.953a1.823,1.823,0,0,0,1.631,3.262Z",
    transform: "translate(-395.178 -42.339)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215666",
    "data-name": "Path 215666",
    d: "M456.4,194.944l-3.906-1.953a1.823,1.823,0,0,0-1.631,3.262l3.906,1.953a1.823,1.823,0,0,0,1.631-3.262Z",
    transform: "translate(-395.178 -169.363)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215667",
    "data-name": "Path 215667",
    d: "M38.678,50.343l-3.906-1.953a1.823,1.823,0,0,0-1.631,3.262L37.047,53.6a1.823,1.823,0,0,0,1.631-3.262Z",
    transform: "translate(-28.227 -42.338)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215668",
    "data-name": "Path 215668",
    d: "M37.047,192.991l-3.906,1.953a1.823,1.823,0,0,0,1.631,3.262l3.906-1.953a1.823,1.823,0,0,0-1.631-3.262Z",
    transform: "translate(-28.227 -169.363)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215669",
    "data-name": "Path 215669",
    d: "M146.252,316.528l-8.818,8.819a5.693,5.693,0,0,1-4.05,1.678h-6.617a1.857,1.857,0,0,1-1.873-1.735,1.823,1.823,0,0,1,1.821-1.911h5.9a3.906,3.906,0,0,0,0-7.812H120.728a7.717,7.717,0,0,0-7.574,5.859h-2.821v13.411h25.143a8.437,8.437,0,0,0,6-2.487l13.238-13.238a1.823,1.823,0,0,0-.009-2.587A5.963,5.963,0,0,0,146.252,316.528Z",
    transform: "translate(-96.921 -276.507)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215670",
    "data-name": "Path 215670",
    d: "M7.942,337.4H1.823A1.823,1.823,0,0,0,0,339.223V356.8a1.823,1.823,0,0,0,1.823,1.823H7.941A1.823,1.823,0,0,0,9.765,356.8V339.223A1.823,1.823,0,0,0,7.942,337.4Z",
    transform: "translate(0 -296.388)",
    fill: "#ff4f01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage1);
export default __webpack_public_path__ + "static/media/advantage1.01a583baf231182176ed9892c033b826.svg";
export { ForwardRef as ReactComponent };